
export {InsertParagraphCommand,
Paragraph,
ParagraphButtonUI,
ParagraphCommand} from '../../../frontend-editor-ckeditor-web/__liferay__/exports/@ckeditor$ckeditor5-paragraph$dist$index.js.js';
